import { pickGmwLibraryFields } from "../../../schema/gmw-schema-library";

import { SourcedocumentDataSchemaFor } from "./_gmw-event-schema-collection";

export const gmwOwnerSchema: SourcedocumentDataSchemaFor<"GMW_Owner"> = {
  type: "object",
  title: "Gebeurtenis gegevens",
  required: ["eventDate", "owner"],
  properties: pickGmwLibraryFields(["eventDate", "owner"]),
};
